import { object, shape, string } from 'prop-types';

const messageDescriptor = shape({
    id: string.isRequired,
    defaults: string,
    values: object,
    formats: object,
});

export default messageDescriptor;
